import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./slices/authSlice";
import templeSlice from "./slices/templeSlice";
import packageSlice from "./slices/packageSlice";
import priceSlice from "./slices/priceSlice";
import homepageSlice from "./slices/homepageSlice";
import userSlice from "./slices/userSlice";
import cartSlice from "./slices/cartSlice";
import locationSlice from "./slices/locationSlice";
import customizeSlice from "./slices/customizeSlice";
import contactUsSlice from "./slices/contactUsSlice";
import faqChatSlice from "./slices/faqChatSlice";
import reviewSlice from "./slices/reviewSlice";
import paymentSlice from "./slices/paymentSlice";
import emailSlice from "./slices/emailSlice";
import reportSlice from "./slices/reportSlice";
import termSlice from "./slices/termSlice";

export default configureStore({
  reducer: {
    authSlice,
    templeSlice,
    packageSlice,
    priceSlice,
    homepageSlice,
    userSlice,
    cartSlice,
    locationSlice,
    customizeSlice,
    contactUsSlice,
    faqChatSlice,
    reviewSlice,
    paymentSlice,
    emailSlice,
    reportSlice,
    termSlice
  },
});
